<template>
  <div>
    <navbar back fixed bg>
      <span slot="title">实名认证</span>
    </navbar>
    <!--<div class="page-content">-->
    <!--<form @submit.prevent="submitHandler" novalidate="novalidate">-->
    <!--<div class="group-title">实名信息</div>-->
    <!--<div class="cell-group">-->
    <!--<div class="input-cells">-->
    <!--<div class="label-cell">-->
    <!--<label>真实姓名</label>-->
    <!--</div>-->
    <!--<div class="input-cell">-->
    <!--<input type="text" v-model="name" class="form-control">-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="input-cells">-->
    <!--<div class="label-cell">-->
    <!--<label>身份证号</label>-->
    <!--</div>-->
    <!--<div class="input-cell">-->
    <!--<input type="text" v-model="idcard" class="form-control">-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="btn-group">-->
    <!--<button type="submit" class="btn-submit" @click="submitHandler">保存</button>-->
    <!--</div>-->
    <!--</form>-->
    <!--</div>-->
    <!--<spinner :show="loading"></spinner>-->
    <!--<toast :show="toastShow" :text="toastText" @hidden="toastShow=false"></toast>-->
    <div class="page-content">
      <div class="page-caption">
        <h3 class="group-title" style="margin-top: 132px;font-size: 24px;">温馨提示</h3>
        <div class="point"></div>
        <p class="bottom group-title">请使用APP来完成实名认证操作，如未安装APP请前往下载页面安装。</p>
      </div>
      <div class="btn-group">
        <button type="submit" class="btn-submit" @click="goApp">立即前往</button>
      </div>
    </div>
  </div>
</template>

<script>
  import Navbar from 'components/navbar/navbar'
  import Spinner from 'components/spinner/spinner'
  import Toast from 'components/toast/toast'

  export default {
    data () {
      return {
        loading: false,
        toastShow: false,
        toastText: '',
        name: '',
        idcard: ''
      }
    },
    components: {
      Navbar,
      Spinner,
      Toast
    },
    created () {
      this.token = this.$cache.getUserToken()
    },
    methods: {
      _validate () {
        if (!this.name) {
          this.toastText = '请输入真实姓名'
          return !(this.toastShow = true)
        }
        if (!this.idcard) {
          this.toastText = '请输入身份证号'
          return !(this.toastShow = true)
        }
        if (!/^[1-9](([0-9]{14})|([0-9]{16}[0-9xX]))$/.test(this.idcard)) {
          this.toastText = '请输入正确的身份证号'
          return !(this.toastShow = true)
        }
        return true
      },
      submitHandler () {
        if (this._validate()) {
          let vm = this
          this.loading = true
          this.$ajax({
            url: '/center/realNameAuthentication.jhtml',
            params: {
              uid: vm.token.uid,
              name: vm.name,
              idcard: vm.idcard
            },
            done (o, p, r) {
              vm.$dialog({
                content: r.msg,
                onHide () {
                  vm.$router.replace('/user')
                }
              })
            },
            fail (m) {
              vm.$dialog(m)
            },
            always () {
              vm.loading = false
            }
          })
        }
      },
      goApp () {
        window.location.href = 'https://image.91weijia.com/91weijia/app/zapp-wap/index.html?from=singlemessage&isappinstalled=0'
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'

  .group-title
    text-align center

  .cell-group
    box-shadow 0 px2rem(10) px2rem(15) rgba(171,185,197, 1)

  .group-title
    margin px2rem(18) 0 px2rem(15) 1em
    font-size px2rem(24)
    color #275482

  .btn-group
    margin-top px2rem(60)
    width 80%
    margin-left 10%
    .btn-submit
      width 100%
      height px2rem(80)
      font-size px2rem(32)
      color #fff
      border none
      border-radius px2rem(8)
      background-color #60c9c8
      box-shadow 0 0 px2rem(4) rgba(18,119,163, .75)
</style>



// WEBPACK FOOTER //
// authentication.vue?7f495ee3